import {
  Component, Input, Output, EventEmitter,
  ViewEncapsulation, TemplateRef, ViewChild
} from '@angular/core';

/*
 * Tabla para mostrar información 
 *
 * 10/04/2019
 * By: Jsolerh
 * 
 */
@Component({
  selector: 'component-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DatatableComponent {

  @Input() public rows: Array<any> = [];
  @Input() public columns: Array<any> = [];
  @Input() public rowToGroup: string;
  @Input() public titleToGroup: string;
  @Input() public totalBines: number;


  @ViewChild('columButtomTemplate') public columButtomTemplate: TemplateRef<any>;
  @ViewChild('checkTemplateBinManeger') public checkTemplateBinManeger: TemplateRef<any>;
  @ViewChild('buttomTemplateOptionsBinManeger') public buttomTemplateOptionsBinManeger: TemplateRef<any>;
  @ViewChild('columButtomSearch') public columButtomSearch: TemplateRef<any>;
  @ViewChild('columButtomTemplateOptions') public columButtomTemplateOptions: TemplateRef<any>;
  @ViewChild('columProc') public columProc: TemplateRef<any>;
  @ViewChild('columIns') public columIns: TemplateRef<any>;
  @ViewChild('columEsqu') public columEsqu: TemplateRef<any>;
  @ViewChild('columCamp') public columCamp: TemplateRef<any>;
  @ViewChild('columPlantilla') public columPlantilla: TemplateRef<any>;
  @ViewChild('columSeccion') public columSeccion: TemplateRef<any>;
  @ViewChild('columConfig') public columConfig: TemplateRef<any>;
  // Emitter evento para click de boton y toggle
  @Output() public onEventTemplate: EventEmitter<Object>;

  public messages = {
    // Message to show when array is presented
    // but contains no values
    emptyMessage: 'No hay información para mostrar',

    // Footer total message
    totalMessage: 'total'
  };

  page = {
    pageNumber: 0,
    limit: 6,
  }

  page2 = {
    pageNumber: 0,
    limit: 3,
  }


  constructor() {
    this.onEventTemplate = new EventEmitter();
  }

  onclickTemplateBM(target, rowData, accion, grupo) {
    this.onEventTemplate.emit({
      targetSelect: target,
      rowSelect: rowData,
      accion: accion,
      grupo: grupo
    });
  }

  onclickNew(target, rowData, accion) {

    this.onEventTemplate.emit({
      targetSelect: target,
      rowSelect: rowData,
      accion: accion,
    })
  }

  onclickNewIns(target, rowData, accion) {
    this.onEventTemplate.emit({
      targetSelect: target,
      rowSelect: rowData,
      accion: accion,
    })
  }
  onclickNewEsqu(target, rowData, accion) {
    this.onEventTemplate.emit({
      targetSelect: target,
      rowSelect: rowData,
      accion: accion,
    })
  }

  onclickNewPlantilla(target, rowData, accion) {
    this.onEventTemplate.emit({
      targetSelect: target,
      rowSelect: rowData,
      accion: accion,
    })
  }

  onclickNewSeccion(target, rowData, accion){
    this.onEventTemplate.emit({
    targetSelect: target,
    rowSelect: rowData,
    accion: accion,
    })
  }

  onclickNewCamp(target, rowData, accion) {
    this.onEventTemplate.emit({
      targetSelect: target,
      rowSelect: rowData,
      accion: accion,
    })
  }

  onclickNewConfig(target, rowData, accion) {
    this.onEventTemplate.emit({
      targetSelect: target,
      rowSelect: rowData,
      accion: accion,
    })
  }
  /*
   * Cambio de paginado  
   */
  onPageChange(currentPagaNumber: number) {
    //limita al paginador a tener numeros menos 0
    if (currentPagaNumber < 0) {
      this.page.pageNumber = 0;
    }
    this.page.pageNumber = (currentPagaNumber) - 1;
  }
}
